import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS } from "@/data/content";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.6"] });
  const lineHeight = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section data-testid="process-section" className="relative py-28 md:py-44 bg-surface/40">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <SectionHeading chapter="04" overline="Process" title="From Idea to Impact" />

        <div ref={ref} className="relative">
          <div className="absolute left-[19px] md:left-[27px] top-0 bottom-0 w-px bg-white/[0.08]" />
          <motion.div
            style={{ height: lineHeight }}
            className="absolute left-[19px] md:left-[27px] top-0 w-px bg-gold shadow-[0_0_12px_rgba(229,169,60,0.6)]"
            data-testid="process-line-fill"
          />
          <div className="space-y-14 md:space-y-20">
            {PROCESS.map((p, i) => (
              <Reveal key={p.step} delay={0.05 * i}>
                <div className="relative flex gap-6 md:gap-12 pl-2" data-testid={`process-step-${p.step}`}>
                  <span className="relative z-10 flex h-9 w-9 md:h-14 md:w-14 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-void font-mono text-xs md:text-sm text-gold">
                    {p.step}
                  </span>
                  <div className="pt-1 md:pt-3">
                    <h3 className="font-display text-2xl md:text-3xl font-semibold text-zinc-50">{p.title}</h3>
                    <p className="mt-3 max-w-lg text-sm md:text-base text-zinc-500 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
